import { SVGProps } from "react";

export const BaseLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 111 111" {...props}>
    <circle cx="55.5" cy="55.5" r="55.5" fill="#0052FF" />
    <path
      fill="#FFFFFF"
      d="M55.4 93.3c20.9 0 37.8-16.9 37.8-37.8 0-20.9-16.9-37.8-37.8-37.8-19.6 0-35.7 14.9-37.6 34H69v7.6H17.8c1.9 19.1 18 34 37.6 34z"
    />
  </svg>
);
